import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'
import HTTP from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from 'cityads-v3/config';

import { AVAILABLE_LANGUAGES, AVAILABLE_NAMESPACES } from './utils';

export const options = {
  fallbackLng: 'en',
  load: 'currentOnly',
  supportedLngs: [...AVAILABLE_LANGUAGES],
  debug: config.DEBUG,

  interpolation: {
    escapeValue: false,
  },

  react: {
    wait: false, // set to true if you like to wait for loaded in every translated hoc
    nsMode: 'default', // set it to fallback to let passed namespaces to translated hoc act as fallbacks
    useSuspense: false,
  },

  detection: {
    order: ['cookie', 'localStorage', 'navigator'],
    lookupCookie: 'ca_lang',
    lookupLocalStorage: 'ca_lang',
    caches: ['localStorage', 'cookie'],
  },

  ns: AVAILABLE_NAMESPACES,
  defaultNS: 'main',

  ...(
    typeof window !== 'undefined' && window.initialI18nStore ? {
      resources: {
        ...window.initialI18nStore
      }
    } : {}
  ),

  backend: {
    loadPath: '/static/locales/{{lng}}/{{ns}}.json',
    ajax: function (url, options, callback, data) {

      fetch(url, {
        headers: {
          Accept: 'text/html' // для глупого webpackDevServer
        }
      })
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
          return response;
        })
        .then(response => response.text())
        .then(json => {
          callback(json, {
            status: 200
          });
        }).catch(() => {
          callback(null, {status: '404'})
        })

    }
  }
};


i18n
  .use(HTTP)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(options)
;

export default i18n;
